export default [

    {
        path: '/selecet/account',
        component: () => import('../pages/selecet/account/index.vue'),
        meta: { title: ' 新媒体账号' }
    },
    {
        path: '/selecet/selectedtopic',
        component: () => import('../pages/selecet/selectedtopic/index.vue'),
        meta: { title: ' 选题规划' }
    },
    {
        path: '/selecet/original',
        component: () => import('../pages/selecet/original/index.vue'),
        meta: { title: '创作中心' }
    }, {
        path: '/selecet/release',
        component: () => import('../pages/selecet/release/index.vue'),
        meta: { title: '进度日程' }
    },

]